import { WebhookDoc } from '@upflowy/types';

import { StateEvent } from '../types';

const stepIsSynchronous = (webhooks: WebhookDoc[], event: StateEvent) => {
  let isSync = false;
  webhooks.forEach((hook) => {
    if (hook.action === event.type && hook.target === 'step' && hook.async === false) {
      isSync = true;
    }
  });
  return isSync;
};

export default stepIsSynchronous;
